export const ruTranslations = {
  langSwitcher: {
    aria: 'Сменить язык',
    ru: 'Русский',
    en: 'English',
  },

  nav: {
    allTools: 'Все инструменты',
    blog: 'Блог',
  },

  badge: {
    local: 'Локально',
    server: 'На сервере',
    localFirst: 'Локально*',
    localTitle: 'Текст обрабатывается прямо в браузере и не отправляется на сервер',
    serverTitle: 'Текст отправляется на сервер для обработки',
    localFirstTitle:
      'По умолчанию обработка происходит в браузере. При необходимости доступна серверная опция.',
  },

  common: {
    textTools: 'Инструменты',
    scenarios: 'Сценарии',
    howTo: 'Как пользоваться',
    faq: 'Вопросы',
    otherTools: 'Другие инструменты',
    allTools: 'Все инструменты',
    updated: 'Обновлено',
    allBlogPosts: 'Все записи блога',
  },

  hero: {
    title: 'Инструменты для текста онлайн',
    description:
      'Считайте символы, удаляйте дубли, чистите и преобразуйте текст прямо в браузере. Без регистрации.',
  },

  catalog: {
    title: 'Каталог инструментов',
  },

  categories: {
    count: 'Считать',
    clean: 'Чистить',
    format: 'Форматировать',
    generate: 'Генерировать',
    seo: 'SEO и соцсети',
  },

  tools: {
    textCounter: {
      title: 'Счётчик символов',
      shortDescription: 'Символы, слова, строки, абзацы и размер текста в UTF-8.',
      longDescription:
        'Быстрый счётчик для черновиков, SEO-текстов, интерфейсных строк и постов с лимитами. Текст обрабатывается локально в браузере.',
      seoTitle: 'Счётчик символов онлайн: количество символов и слов — txtify.ru',
      seoDescription:
        'Посчитайте количество символов, слов, строк, абзацев и размер текста в UTF-8. Бесплатно, без регистрации и без отправки данных на сервер.',
      useCases: ['SEO title и description', 'Посты с лимитами', 'Строки интерфейса', 'Размер в UTF-8'],
      howTo: [
        'Вставьте текст в редактор.',
        'Смотрите показатели сразу во время набора.',
        'Скопируйте текст обратно или очистите поле.',
      ],
      faq: [
        {
          question: 'Текст отправляется на сервер?',
          answer: 'Нет. Счётчик работает в браузере, текст не покидает устройство.',
        },
        {
          question: 'Emoji считаются корректно?',
          answer:
            'Да. Если браузер поддерживает Intl.Segmenter, составные символы считаются как видимые графемы.',
        },
      ],
    },
    textCase: {
      title: 'Регистр текста',
      shortDescription: 'UPPERCASE, lowercase, Title Case и sentence case.',
      longDescription:
        'Быстрое приведение заголовков, списков и импортированных строк к нужному регистру.',
      seoTitle: 'Изменить регистр текста онлайн — txtify.ru',
      seoDescription: 'Преобразуйте текст в верхний, нижний, заголовочный или обычный регистр.',
      useCases: ['Заголовки', 'Импортированные списки', 'Нормализация копирайта'],
      modeLowerHint: 'все буквы строчные',
      modeUpperHint: 'все буквы заглавные',
      modeTitleHint: 'каждое слово с большой',
      modeSentenceHint: 'первое слово с большой',
      modeCapitalizeHint: 'только первая буква',
      howTo: [
        'Вставьте или напечатайте текст в левом поле.',
        'Выберите режим преобразования: lowercase, UPPERCASE, Title Case, Sentence case или Capitalize.',
        'Скопируйте результат или обменяйте вход и выход кнопкой «Обменять».',
      ],
      faq: [
        {
          question: 'Текст отправляется на сервер?',
          answer: 'Нет. Преобразование регистра происходит локально в браузере. Текст не покидает ваше устройство.',
        },
        {
          question: 'Работает ли с русским текстом?',
          answer: 'Да. Все режимы корректно обрабатывают русский текст, включая букву «ё» и составные символы.',
        },
        {
          question: 'Чем отличается Title Case от Capitalize?',
          answer: 'Title Case делает заглавной первую букву каждого слова. Capitalize — только первую букву всего текста, остальные оставляет без изменений.',
        },
      ],
    },
    dedupeLines: {
      title: 'Удалить дубли ключевых слов, фраз и строк',
      shortDescription: 'Оставить по одному вхождению каждого ключевого слова, фразы или строки.',
      longDescription:
        'Удаляйте дубли ключевых слов, фраз и строк с понятными правилами сравнения. Первое вхождение и исходный порядок сохраняются.',
      seoTitle: 'Удаление дублей ключевых слов и фраз онлайн — txtify.ru',
      seoDescription:
        'Удалите дубли ключевых слов и фраз онлайн: уберите дубликаты строк из списка с учётом регистра и пробелов. Порядок сохранится, текст останется в браузере.',
      useCases: ['Списки ключевых слов', 'Повторяющиеся фразы', 'Email-выгрузки', 'Перечни и чек-листы'],
      howTo: [
        'Поместите каждый элемент, строку или фразу на отдельную строку и вставьте текст в левое поле.',
        'При необходимости включите сравнение без учёта регистра или внешних пробельных символов Unicode и удаление пустых строк.',
        'Проверьте статистику: первое вхождение каждого элемента останется на исходном месте.',
        'Скопируйте результат или скачайте его как .txt.',
      ],
      faq: [
        {
          question: 'Данные отправляются на сервер?',
          answer: 'Нет. Инструмент работает локально в браузере, текст не покидает устройство.',
        },
        {
          question: 'Что считается дубликатом?',
          answer:
            'По умолчанию совпадение должно быть точным: регистр и пробельные символы по краям учитываются. Эти правила можно явно отключить в настройках сравнения.',
        },
        {
          question: 'Как разделяются элементы списка и фразы?',
          answer:
            'Один элемент или фраза должны занимать одну строку. Запятая внутри строки остаётся частью текста и не используется как разделитель.',
        },
        {
          question: 'Изменится ли порядок или написание строк?',
          answer:
            'Нет. Инструмент всегда сохраняет первое вхождение на его исходном месте и выводит его без изменения регистра или пробелов.',
        },
        {
          question: 'Что происходит с пустыми строками?',
          answer:
            'По умолчанию они участвуют в сравнении: первое пустое место сохраняется, последующие считаются дублями. Отдельная настройка удаляет строки только из пробельных символов Unicode и показывает их количество не как дубли.',
        },
      ],
      page: {
        sourceText: 'Исходный текст',
        resultText: 'Результат',
        ignoreCase: 'Без учёта регистра',
        ignoreCaseDesc: 'Заглавные и строчные буквы считаются одинаковыми',
        ignoreOuterSpaces: 'Без пробелов по краям',
        ignoreOuterSpacesDesc: 'Пробелы по краям не мешают сравнению, а в результате остаются',
        removeBlankLines: 'Удалять пустые строки',
        removeBlankLinesDesc: 'Убрать пустые строки и строки из одних пробелов',
        clear: 'Очистить',
        copy: 'Копировать',
        copied: 'Скопировано',
        download: 'Скачать .txt',
        inputPlaceholder: 'Вставьте ключевые слова или фразы, по одной на строку...',
        outputPlaceholder: 'Результат появится здесь после ввода...',
        inputAriaLabel: 'Исходный текст для удаления дублей строк',
        outputAriaLabel: 'Результат удаления дублей',
        optionsTitle: 'Настройки обработки',
        statsTitle: 'Статистика',
        statTotal: 'Всего строк',
        statUnique: 'Осталось уникальных',
        statRemoved: 'Удалено дублей',
        statBlankRemoved: 'Удалено пустых',
        linesUnit: 'строк',
        duplicatesUnit: 'дублей',
        itemRule: 'Один элемент списка или одна фраза — одна строка. Запятые внутри строки остаются частью текста.',
        orderRule: 'Первое вхождение всегда сохраняется на исходном месте и выводится без изменения написания.',
        howTitle: 'Как это работает',
        howText: 'Инструмент сравнивает элементы построчно и оставляет первое вхождение каждого из них. По умолчанию регистр и внешние пробельные символы Unicode учитываются. Опции меняют только ключ сравнения: сохранённая строка остаётся без преобразований. Удаление пустых строк включается независимо.',
        whenTitle: 'Когда полезно',
        whenText: 'Очистка списков ключевых слов, повторяющихся фраз, email-адресов, перечней и чек-листов, где каждый элемент записан на отдельной строке.',
      },
    },
    textCleanup: {
      title: 'Очистить текст',
      shortDescription: 'Убрать лишние пробелы, пустые строки и переносы внутри абзацев.',
      longDescription:
        'Безопасная локальная очистка текста после PDF, OCR и email с предпросмотром изменений.',
      seoTitle: 'Убрать лишние пробелы и переносы строк онлайн — txtify.ru',
      seoDescription:
        'Очистите текст от лишних пробелов, табуляций, пустых строк и переносов внутри абзацев. Локально в браузере, с предпросмотром изменений.',
      useCases: ['Текст из PDF и OCR', 'Письма', 'Черновики', 'Скопированные абзацы'],
      howTo: [
        'Вставьте текст и выберите только нужные правила очистки.',
        'Сравните исходный текст и результат в предпросмотре before/after.',
        'Проверьте счётчики и скопируйте очищенный текст.',
      ],
      faq: [
        {
          question: 'Текст отправляется на сервер?',
          answer:
            'Нет. Очистка и предпросмотр выполняются локально в браузере; текст не отправляется и не сохраняется.',
        },
        {
          question: 'Склеятся ли разные абзацы?',
          answer:
            'Нет. Объединение переносов работает только между непустыми строками внутри абзаца. Пустая строка остаётся границей; при удалении пустых строк соседние абзацы сохраняются отдельными строками.',
        },
        {
          question: 'Какие символы изменяются?',
          answer:
            'Инструмент не нормализует Unicode и не меняет пунктуацию. Неразрывные пробелы сохраняются. Меняются только явно выбранные ASCII-пробелы, табуляции и границы строк.',
        },
      ],
      page: {
        presetsTitle: 'Правила очистки',
        normalizeSpaces: 'Нормализовать пробелы',
        normalizeSpacesDescription: 'Заменить серии обычных пробелов одним; неразрывные пробелы сохранить',
        removeEmptyLines: 'Убрать пустые строки',
        removeEmptyLinesDescription: 'Удалить пустые строки, сохранив абзацы отдельными строками',
        joinWrappedLines: 'Объединить переносы',
        joinWrappedLinesDescription: 'Соединить строки внутри абзаца, но не склеивать абзацы',
        tabsToSpaces: 'Табуляции → пробелы',
        tabsToSpacesDescription: 'Заменить каждый tab двумя обычными пробелами',
        trimLines: 'Обрезать строки',
        trimLinesDescription: 'Убрать пробелы и табуляции по краям каждой строки',
        sourceText: 'Исходный текст',
        resultText: 'Очищенный текст',
        inputPlaceholder: 'Вставьте текст после PDF, OCR или письма...',
        outputPlaceholder: 'Результат появится здесь',
        clear: 'Очистить',
        copy: 'Копировать',
        copied: 'Скопировано',
        copyError: 'Не удалось скопировать',
        characters: 'символы',
        lines: 'строки',
        emptyLines: 'пустые строки',
        diffTitle: 'Предпросмотр изменений',
        before: 'До',
        after: 'После',
        changed: 'Есть изменения',
        unchanged: 'Без изменений',
        previewClipped: 'Предпросмотр ограничен первыми 2 000 символами; полный результат доступен выше.',
        limit: 'Лимит: {characters} символов и {lines} строк.',
        characterLimitError: 'Текст превышает лимит символов. Сократите его и повторите.',
        lineLimitError: 'Текст превышает лимит строк. Разделите его на несколько частей.',
        policyTitle: 'Предсказуемая нормализация',
        policyText:
          'Unicode и пунктуация сохраняются без NFC/NFKC-нормализации. Неразрывные пробелы не меняются. Для результата используется преобладающий тип переноса исходника: LF, CRLF или CR; при равенстве выбирается LF.',
      },
    },
    transliteration: {
      title: 'Транслитерация',
      shortDescription: 'Имя на латинице, ГОСТ, URL slug и обратный транслит.',
      longDescription:
        'Локальная транслитерация русского текста по таблице ICAO для документов, упрощённому ГОСТ, правилам URL slug или в обратную сторону.',
      seoTitle: 'Транслитерация онлайн — имя латиницей, ГОСТ и slug — txtify.ru',
      seoDescription:
        'Переведите русский текст в латиницу по ICAO или ГОСТ, создайте URL slug либо выполните обратный транслит. Локально, без отправки текста на сервер.',
      useCases: ['Имя на латинице', 'ГОСТ', 'URL slug', 'Обратный транслит'],
      howTo: [
        'Выберите режим: паспорт/ICAO, ГОСТ, URL slug или обратный транслит.',
        'Введите текст и проверьте результат, который обновляется сразу в браузере.',
        'Скопируйте результат и сверьте официальное написание с требованиями документа.',
      ],
      faq: [
        {
          question: 'Можно использовать результат для загранпаспорта?',
          answer:
            'Режим ICAO даёт справочное преобразование по таблице Doc 9303. Для заявления и поездки используйте написание из уже выданного документа либо требования органа, который его оформляет.',
        },
        {
          question: 'Чем отличаются ICAO и ГОСТ?',
          answer:
            'ICAO предназначен для машиносчитываемых проездных документов и использует заглавную латиницу. ГОСТ Р 7.0.34-2014 задаёт упрощённую транслитерацию русского письма и сохраняет регистр.',
        },
        {
          question: 'Обратная транслитерация точная?',
          answer:
            'Нет. Несколько русских букв могут давать одинаковые латинские сочетания, поэтому обратный режим показывает только наиболее вероятный вариант.',
        },
        {
          question: 'Текст отправляется на сервер?',
          answer:
            'Нет. Все четыре режима выполняются локально в браузере; исходный текст и результат не отправляются и не попадают в аналитику.',
        },
      ],
    },
    fancyText: {
      title: 'Красивый Unicode-текст: латиница меняется, кириллица сохраняется',
      shortDescription: 'Восемь Unicode-стилей для латиницы и части цифр с точным исходником.',
      longDescription:
        'Локальное преобразование Basic Latin в восемь наборов Unicode-символов. Кириллица, emoji и неподдерживаемые графемы остаются без изменений.',
      seoTitle: 'Красивый текст Unicode онлайн — 8 стилей — txtify.ru',
      seoDescription:
        'Преобразуйте латинские буквы и часть цифр в 8 наборов Unicode-символов. Кириллица сохраняется. Локально, без отправки текста на сервер.',
      useCases: ['Подписи и профили', 'Ники', 'Короткие акценты', 'Копирование с точным исходником'],
      howTo: [
        'Введите текст: Basic Latin преобразуется, а кириллица и неподдерживаемые графемы сохраняются.',
        'Проверьте восемь именованных вариантов и предупреждения о покрытии.',
        'Скопируйте выбранный вариант или точный исходный текст и проверьте результат после вставки.',
      ],
      faq: [
        {
          question: 'Это новый шрифт?',
          answer:
            'Нет. Инструмент заменяет некоторые латинские буквы и цифры отдельными Unicode-символами. Файл шрифта не создаётся и не загружается.',
        },
        {
          question: 'Почему русские буквы не меняются?',
          answer:
            'Выбранные математические наборы Unicode не содержат прямых соответствий для русской кириллицы. Она сохраняется без подмены похожими латинскими или греческими буквами.',
        },
        {
          question: 'Результат одинаково выглядит везде?',
          answer:
            'Не обязательно. Отображение, фильтрация и подсчёт зависят от устройства и места вставки, поэтому всегда проверяйте готовый текст после вставки.',
        },
        {
          question: 'Текст отправляется на сервер?',
          answer:
            'Нет. Преобразование и копирование выполняются локально; введённый и скопированный текст не отправляется и не сохраняется.',
        },
      ],
    },
    seoLimits: {
      title: 'Проверка сниппета и SEO-лимитов',
      shortDescription: 'Длина title, description, сниппета и текста анонса.',
      longDescription:
        'Локальная проверка длины SEO title, description, сниппета и анонса перед публикацией. Диапазоны — нейтральные редакторские ориентиры, а не обещание показа в конкретной платформе.',
      seoTitle: 'Проверить сниппет, title и description онлайн — txtify.ru',
      seoDescription:
        'Проверьте сниппет перед публикацией: длину SEO title, description и текста анонса. Бесплатно, без регистрации и отправки текста на сервер.',
      useCases: ['SEO title', 'Description', 'Сниппет', 'Текст анонса'],
      howTo: [
        'Вставьте SEO title, description или другой текст сниппета в нужное поле.',
        'Смотрите количество символов и статус: мало, в диапазоне или больше ориентира.',
        'Сократите или допишите текст и перенесите готовый вариант в CMS.',
      ],
      faq: [
        {
          question: 'Это точные лимиты поисковых систем?',
          answer:
            'Нет. Инструмент показывает нейтральные редакторские диапазоны. Реальный вид сниппета зависит от устройства, запроса, языка и решения конкретной платформы.',
        },
        {
          question: 'Текст отправляется на сервер?',
          answer:
            'Нет. Подсчёт выполняется локально в браузере, текст не отправляется и не сохраняется.',
        },
        {
          question: 'Почему считаются символы, а не пиксели?',
          answer:
            'Символьный диапазон быстрее проверять в редакторском процессе. Пиксельная ширина зависит от шрифта, интерфейса и конкретного места показа.',
        },
      ],
    },
    passwordGenerator: {
      title: 'Генератор паролей',
      shortDescription: 'Криптостойкие пароли нужной длины с буквами, цифрами и символами.',
      longDescription: 'Быстрый генератор надёжных паролей для аккаунтов, доступов и тестовых секретов. Пароль создаётся локально в браузере через crypto.getRandomValues, не отправляется на сервер и не сохраняется.',
      seoTitle: 'Генератор паролей онлайн — txtify.ru',
      seoDescription: 'Создайте надёжный пароль локально в браузере: длина, заглавные и строчные буквы, цифры, символы и исключение похожих знаков.',
      useCases: ['Новый аккаунт', 'Временный доступ', 'Тестовый секрет', 'Админ-панель'],
      howTo: [
        'Выберите длину пароля слайдером или числовым полем.',
        'Оставьте нужные наборы символов: буквы, цифры и спецсимволы.',
        'При необходимости включите исключение похожих символов.',
        'Настройки обновляют пароль автоматически; нажмите «Новый пароль», если нужен другой вариант с теми же параметрами.',
      ],
      faq: [
        {
          question: 'Пароль отправляется на сервер?',
          answer: 'Нет. Генерация происходит локально в браузере через crypto.getRandomValues. Пароль не отправляется, не сохраняется и не попадает в analytics.',
        },
        {
          question: 'Можно отключить все наборы символов?',
          answer: 'Нет. Должен остаться хотя бы один набор: строчные буквы, заглавные буквы, цифры или символы.',
        },
        {
          question: 'Что значит исключить похожие символы?',
          answer: 'Инструмент убирает символы вроде 0, O, 1, I и l, чтобы пароль было легче перепечатать без ошибок.',
        },
      ],
    },
  },

  counter: {
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    placeholder: 'Вставьте текст или начните печатать...',
    textareaLabel: 'Текст для подсчёта символов',
    details: 'Детали',
    chars: 'Символов',
    words: 'Слов',
    withoutSpaces: 'Без пробелов',
    lines: 'Строк',
    paragraphs: 'Абзацев',
    sentences: 'Предложений',
    readingMinutes: 'Чтение, мин',
    utf8Bytes: 'UTF-8 байт',
    quickLimits: 'Быстрые лимиты',
    charsShort: 'симв.',
    limits: [
      ['SEO title', 60],
      ['Description', 160],
      ['Пост 280', 280],
    ] as Array<readonly [string, number]>,
    howCountedTitle: 'Как считаются значения',
    howCounted:
      'Символы считаются как видимые графемы, поэтому emoji и составные символы не разваливаются на несколько единиц. В счётчике без пробелов не учитываются пробелы, табуляции и переносы строк.',
    usefulTitle: 'Когда это полезно',
    useful:
      'Счётчик подходит для форм с лимитами, SEO title/description, постов в соцсетях, сообщений, технических текстов и проверки размера строки в UTF-8.',
  },

  caseConverter: {
    sourceText: 'Исходный текст',
    result: 'Результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    swap: 'Обменять',
    inputPlaceholder: 'Вставьте текст...',
    inputLabel: 'Исходный текст для преобразования регистра',
    outputPlaceholder: 'Результат преобразования',
    charsShort: 'симв.',
    modeTitle: 'Режим преобразования',
    statsTitle: 'Статистика',
    statsInput: 'Вход',
    statsOutput: 'Результат',
    statsWords: 'Слов во входе',
    statsMode: 'Режим',
  },

  transliteration: {
    modeTitle: 'Режим транслитерации',
    modes: {
      icao: {
        label: 'Паспорт / ICAO',
        description: 'Заглавная латиница по таблице ICAO Doc 9303.',
      },
      gost: {
        label: 'ГОСТ',
        description: 'Упрощённая транслитерация по ГОСТ Р 7.0.34-2014.',
      },
      slug: {
        label: 'URL slug',
        description: 'Строчные буквы, цифры и дефисы для адреса страницы.',
      },
      reverse: {
        label: 'Обратный — приблизительно',
        description: 'Латиница в кириллицу с неизбежными неоднозначностями.',
      },
    },
    russianInput: 'Русский текст',
    latinInput: 'Текст латиницей',
    inputPlaceholder: 'Например: Юлия Щербакова',
    reversePlaceholder: 'Например: IULIIA SHCHERBAKOVA',
    result: 'Результат',
    outputPlaceholder: 'Транслитерация появится здесь',
    ready: 'Результат транслитерации обновлён.',
    reset: 'Сбросить',
    copy: 'Копировать',
    copied: 'Скопировано',
    copyError: 'Не удалось скопировать',
    characterLimitError: 'Текст превышает лимит 100 000 символов. Разделите его на части.',
    officialTitle: 'Проверьте официальное написание',
    officialText:
      'Результат — справочная трансформация, а не гарантия принятия. Для паспорта, визы, билета или заявления используйте написание из выданного документа и требования принимающей организации.',
    sourcesTitle: 'Стандарты и локальная обработка',
    localText:
      'Таблицы сверены с ICAO Doc 9303 Part 3 и ГОСТ Р 7.0.34-2014. Ввод, результат и содержимое буфера обмена остаются в браузере.',
  },

  fancyText: {
    inputLabel: 'Текст для преобразования в Unicode-символы',
    instructions: 'Стилизуются Basic Latin A–Z и a–z; цифры меняются в четырёх стилях. Кириллица и остальные символы сохраняются.',
    placeholder: 'Например: Hello Привет 123 😀',
    clear: 'Очистить',
    copy: 'Копировать',
    copyOriginal: 'Копировать исходный текст',
    originalStyleName: 'исходный текст',
    copyStyle: 'Копировать Unicode-текст в стиле «{style}»',
    copySuccess: 'Скопирован вариант «{style}». Проверьте результат после вставки.',
    copyError: 'Не удалось скопировать вариант «{style}». Разрешите доступ к буферу и повторите.',
    resultsTitle: 'Восемь Unicode-вариантов',
    emptyResult: 'Введите текст, чтобы увидеть вариант.',
    partialResult: 'Неподдерживаемые графемы сохранены без изменений.',
    unchangedResult: 'В этом тексте нет символов, поддерживаемых данным стилем.',
    coverageTitle: 'Честное покрытие',
    coverageText: 'Все восемь стилей меняют Basic Latin. Цифры меняются только в полужирном, двойном контуре, полужирном без засечек и моноширинном стилях. Кириллица, accented Latin, emoji и другие неподдерживаемые графемы сохраняются целиком.',
    privacy: 'Преобразование выполняется в этом браузере. Введённый и скопированный текст не отправляется на сервер.',
    compatibility: 'Unicode-символы могут выглядеть, фильтроваться и считаться по-разному. Проверьте результат после вставки; инструмент не гарантирует принятие конкретным приложением.',
    accessibility: 'Стилизованный результат может читаться скринридером хуже обычного текста. Рядом всегда доступен точный исходник.',
    safetyWarning: 'Во вводе обнаружены скрытые format-, bidi-, tag- или управляющие символы. Инструмент сохраняет их, но не создаёт новые: проверьте источник перед копированием. Обычные emoji с ZWJ, variation selector или модификатором не вызывают это предупреждение.',
    graphemes: 'Графемы',
    codePoints: 'Кодовые точки',
    utf16Units: 'Единицы UTF-16',
    checkAfterPaste: 'проверьте после вставки',
    graphemeLimitError: 'Не больше 5 000 графем. Последний допустимый текст сохранён.',
    codePointLimitError: 'Не больше 20 000 кодовых точек. Последний допустимый текст сохранён.',
    styles: {
      bold: 'Полужирный',
      italic: 'Курсив',
      'bold-italic': 'Полужирный курсив',
      script: 'Рукописный',
      fraktur: 'Готический',
      'double-struck': 'Двойной контур',
      'sans-serif-bold': 'Полужирный без засечек',
      monospace: 'Моноширинный',
    },
  },

  seoLimits: {
    recommended: 'Рекомендация',
    charactersShort: 'симв.',
    summary: 'Сводка',
    totalCharacters: 'Всего символов',
    filledFields: 'Заполнено полей',
    goodFields: 'В диапазоне',
    noteTitle: 'Как читать диапазоны',
    note:
      'Диапазоны помогают быстро заметить слишком короткие или длинные тексты. Они не гарантируют конкретный вид сниппета: итоговый показ зависит от контекста и интерфейса площадки.',
    rangeTitle: 'Ориентиры',
    fields: {
      title: 'SEO title',
      description: 'Meta description',
      snippet: 'Текст сниппета',
      social: 'Текст анонса',
    },
    placeholders: {
      title: 'Например: Счётчик символов онлайн — txtify.ru',
      description: 'Кратко опишите страницу так, чтобы было понятно содержание и действие.',
      snippet: 'Вставьте фрагмент текста, который должен хорошо смотреться в сниппете.',
      social: 'Короткий текст для карточки, анонса или публикации.',
    },
    states: {
      empty: 'Пусто',
      under: 'Мало',
      good: 'В диапазоне',
      over: 'Длинно',
    },
  },

  passwordGenerator: {
    controls: 'Настройки пароля',
    length: 'Длина',
    lengthUnit: 'символов',
    characterSets: 'Наборы символов',
    uppercase: 'Заглавные буквы',
    lowercase: 'Строчные буквы',
    numbers: 'Цифры',
    symbols: 'Символы',
    excludeAmbiguous: 'Исключить похожие символы',
    excludeAmbiguousHint: 'Убирает 0, O, 1, I и l для ручного ввода без ошибок.',
    generate: 'Новый пароль',
    copy: 'Копировать',
    copied: 'Скопировано',
    result: 'Пароль',
    resultPlaceholder: 'Создаём пароль с выбранными настройками…',
    securityNote: 'Пароль создаётся локально в браузере, не отправляется на сервер и не сохраняется.',
    emptySetError: 'Выберите хотя бы один набор символов.',
    cryptoError: 'Браузер не предоставил безопасный генератор случайных чисел.',
    entropy: 'Энтропия',
    bits: 'бит',
    poolSize: 'Символов в наборе',
    strength: {
      weak: 'Слабый',
      fair: 'Нормальный',
      strong: 'Сильный',
      excellent: 'Очень сильный',
    },
    stats: {
      selectedSets: 'Наборов',
    },
  },

  blog: {
    breadcrumb: 'Блог',
    title: 'Блог txtify',
    description:
      'Практические заметки про текстовые лимиты, очистку строк, форматирование и локальные инструменты в браузере.',
    languageAria: 'Язык статей',
    postLanguageAria: 'Язык статьи',
    empty: 'На этом языке пока нет записей.',
    notFoundTitle: 'Пост не найден',
    notFoundDescription: 'Такой заметки в блоге txtify нет или ссылка устарела.',
    relatedTools: 'Связанные инструменты',
    localeName: {
      ru: 'Русский',
      en: 'English',
    },
  },

  seo: {
    indexTitle: 'Инструменты для текста онлайн бесплатно — txtify.ru',
    indexDescription:
      'Бесплатные локальные инструменты для текста: счётчик символов, очистка, регистр, транслитерация, пароли и SEO-лимиты без отправки текста на сервер.',
    blogTitle: 'Блог txtify - заметки про текстовые инструменты',
    blogDescription:
      'Практические заметки про счётчики символов, SEO-лимиты, очистку строк, форматирование текста и локальную обработку в браузере.',
  },
}

export type Translations = typeof ruTranslations
